import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  IconButton,
  Stack,
  useToast,
} from "@chakra-ui/react";
import { FiTrash } from "react-icons/fi";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const User_Table_View = () => {
  const [events, setEvents] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const toast = useToast();
  const schoolId = sessionStorage.getItem("school_id");
  const studentId = sessionStorage.getItem("student_id"); // Assuming student_id is stored in sessionStorage

  useEffect(() => {
    // Fetch data from the new API when component mounts
    const fetchEvents = async () => {
      try {
        if (schoolId && studentId) {
          const response = await fetch(
            `${BASE_URL}/student/events/list_registration.php?school_id=${schoolId}&student_id=${studentId}`
          );
          const result = await response.json();
          console.log("list_student_reg :", result);

          if (result.success) {
            setEvents(result.data); // Set event data to state
          } else {
            setError(result.message || "Failed to load events");
          }
        } else {
          setError("School ID and Student ID are required.");
        }
      } catch (err) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, [schoolId, studentId]);

  // Pagination logic
  const totalPages = Math.ceil(events.length / rowsPerPage);
  const currentData = events.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when rows per page change
  };

  const handleDelete = async (regId) => {
    try {
      const response = await fetch(
        `${BASE_URL}/admin/events/registration/delete_reg.php`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            reg_id: regId,
            school_id: schoolId,
            user_id: sessionStorage.getItem("user_id"), // Assuming user_id is stored in sessionStorage
          }),
        }
      );

      const result = await response.json();
      if (result.success) {
        toast({
          title: "Deleted successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        // Remove the deleted record from the state
        setEvents((prevEvents) =>
          prevEvents.filter((event) => event.id !== regId)
        );
      } else {
        toast({
          title: "Failed to delete.",
          description: result.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (err) {
      toast({
        title: "Error occurred.",
        description: "Unable to delete record.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  if (loading) {
    return <Box>Loading...</Box>;
  }

  if (error) {
    return <Box>Error: {error}</Box>;
  }

  return (
    <Box overflowX="auto" p={5}>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="flex-start"
        align="center"
        mb={1}
        p={3}
        className="sb"
      >
        <Stack direction="row" align="center">
          <Text mr={2}>Rows Per Page</Text>
          <Select
            width={{ base: "190px", md: "100px" }}
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            borderColor="#E9EDF4"
            maxWidth="100%" // Ensures Select fits in the container
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Select>
        </Stack>
        {/* Search and Filters */}
        {/* <Box
          display="flex"
          flexWrap="nowrap" // Ensures that all items stay in a single line
          justifyContent="flex-end"
          gap={4}
          width="100%"
          marginLeft="auto" // Aligns content to the right
        >
     
        </Box> */}
      </Flex>

      <Box overflowX="auto" maxWidth="100%">
        <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
          <Thead>
            <Tr>
              <Th>Category</Th>
              <Th>Subcategory</Th>
              <Th>Allocated Teacher</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {currentData.map((event, index) => (
              <Tr key={index}>
                <Td>{event.category}</Td>
                <Td>{event.sub_category}</Td>
                <Td>{event.staff_name}</Td>
                <Td>
                  <Flex gap={2}>
                    <IconButton
                      aria-label="Delete"
                      icon={<FiTrash />}
                      colorScheme="red"
                      onClick={() => handleDelete(event.id)}
                    />
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      <Flex justify="end" align="center" className="sb2" p={3}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>

        <Stack direction="row" spacing={2} mx={2}>
          {Array.from({ length: totalPages }, (_, i) => (
            <Button
              key={i}
              onClick={() => handlePageChange(i + 1)}
              colorScheme={currentPage === i + 1 ? "teal" : "gray"}
            >
              {i + 1}
            </Button>
          ))}
        </Stack>

        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
};

export default User_Table_View;
